import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
} from '@react-pdf/renderer';

// Register Roboto font
Font.register({
  family: 'Roboto',
  fonts: [
    {
      src: 'https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4mxP.ttf',
    },
    {
      src: 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlfBBc9.ttf',
      fontWeight: 700,
    },
  ],
});

// Styles
const styles = StyleSheet.create({
  // page: {
  //   padding: 20,
  //   fontSize: 10,
  //   fontFamily: 'Roboto',
  //   lineHeight: 1.5,
  // },
  // page: {
  //   padding: 20,
  //   fontSize: 10,
  //   fontFamily: 'Roboto',
  //   lineHeight: 1.5,
  //   paddingBottom: 40, // <-- Add enough bottom padding
  // },
  page: {
    paddingTop: 30,
    paddingHorizontal: 20,
    paddingBottom: 60, // Must leave space for footer
    fontSize: 10,
    fontFamily: 'Roboto',
    lineHeight: 1.5,
  },


  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 10,
    textDecoration: 'underline',
  },
  userInfoContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    border: '1px solid #000',
    padding: 10,
    marginBottom: 10,
  },
  userInfoDetails: {
    flexGrow: 1,
    paddingRight: 10,
  },
  userInfoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  label: {
    fontWeight: 'bold',
  },
  profileImage: {
    width: 80,
    height: 100,
    border: '1px solid #000',
    objectFit: 'cover',
  },
  summaryTable: {
    border: '1px solid black',
    padding: 6,
    marginBottom: 10,
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '1px solid #ddd',
    paddingVertical: 3,
  },
  questionBlock: {
    border: '1px solid black',
    borderRadius: 4,
    padding: 6,
    marginBottom: 10,
    backgroundColor: '#f9f9f9',
    minPresenceAhead: 100,
  },
  questionTitle: {
    fontWeight: 'bold',
    marginBottom: 4,
  },
  optionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 2,
  },
  optionText: {
    marginLeft: 4,
  },
  correct: {
    color: 'green',
    fontWeight: 'bold',
  },
  incorrect: {
    color: 'red',
    fontWeight: 'bold',
  },
  statusRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 4,
  },
  // footer: {
  //   position: 'absolute',
  //   bottom: 10,
  //   left: 0,
  //   right: 0,
  //   textAlign: 'center',
  //   fontSize: 8,
  //   color: 'grey',
  // },

  footer: {
    position: 'absolute',
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 8,
    fontWeight: 'bold',
    color: 'grey',
  },

});
const formatDateDMY = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date)) return 'Invalid Date';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

  return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
};


const QuizReviewPDF = ({ summaryData, summarySet, state, userDetails }) => (

  <Document>
    <Page size="A4" style={styles.page} wrap>
      <Text style={styles.sectionTitle}>Quiz Review Report</Text>

      {/* User Info + Image */}
      <View style={styles.userInfoContainer}>
        <View style={styles.userInfoDetails}>
          <View style={styles.userInfoRow}>
            <Text style={styles.label}>Name:</Text>
            <Text>{`${userDetails?.firstName || ''} ${userDetails?.lastName || ''}`}</Text>
          </View>
          <View style={styles.userInfoRow}>
            <Text style={styles.label}>Employee ID:</Text>
            <Text>{userDetails?.employeeId || 'N/A'}</Text>
          </View>
          <View style={styles.userInfoRow}>
            <Text style={styles.label}>Email:</Text>
            <Text>{userDetails?.emailId || 'N/A'}</Text>
          </View>
          <View style={styles.userInfoRow}>
            <Text style={styles.label}>Mobile:</Text>
            <Text>{userDetails?.mobileNo || 'N/A'}</Text>
          </View>
          <View style={styles.userInfoRow}>
            <Text style={styles.label}>Role:</Text>
            <Text>{userDetails?.role || 'N/A'}</Text>
          </View>
        </View>

        {/* {userDetails?.profileImage && (
          <Image style={styles.profileImage} src={userDetails.profileImage} />
        )} */}
      </View>

      {/* Quiz Summary */}
      <View style={styles.summaryTable}>
        <View style={styles.summaryRow}>
          <Text>Started On:</Text>
          <Text>{state?.startTime ? formatDateDMY(state.startTime) : 'N/A'}</Text>
        </View>
        <View style={styles.summaryRow}>
          <Text>Completed On:</Text>
          <Text>{state?.endTime ? formatDateDMY(state.endTime) : 'N/A'}</Text>
        </View>
        <View style={styles.summaryRow}>
          <Text>Time Taken:</Text>
          <Text>{state?.timeTaken || 'N/A'}</Text>
        </View>
        <View style={styles.summaryRow}>
          <Text>Status:</Text>
          <Text style={summarySet?.mark >= 5 ? styles.correct : styles.incorrect}>
            {summarySet?.grade >= 70 ? 'Passed' : 'Failed'}
          </Text>
        </View>
        <View style={styles.summaryRow}>
          <Text>Total Marks:</Text>
          <Text>{summarySet?.mark}/{summarySet?.noOfQuestions}</Text>
        </View>
        <View style={styles.summaryRow}>
          <Text>Grade:</Text>
          <Text>{summarySet?.grade || 0} %</Text>
        </View>
        {/* <View style={styles.summaryRow}>
          <Text>Percentage:</Text>
          <Text>{(summarySet?.mark * 10).toFixed(2)}%</Text>
        </View> */}
      </View>

      {/* Questions */}
      {summaryData?.map((q, index) => (
        <View key={index} style={styles.questionBlock} wrap={false}>
          <Text style={styles.questionTitle}>Question {index + 1}:</Text>
          <Text>{q.question.question}</Text>

          <View style={styles.statusRow}>
            <Text>Status:</Text>
            <Text style={q.isCorrect === 1 ? styles.correct : styles.incorrect}>
              {q.isCorrect === 1 ? 'Correct' : 'Incorrect'}
            </Text>
          </View>
          <View style={styles.statusRow}>
            <Text>Mark:</Text>
            <Text>{q.isCorrect === 1 ? '1 / 1' : '0 / 1'}</Text>
          </View>

          {/* Options */}
          {q.question.options.slice(0, -1).map((opt, i) => {
            const isSelected = q.selected_option === `${i + 1}`;
            const isCorrect = opt.isCorrect;
            const optionText = opt[`option${i + 1}`];

            return (
              <View key={i} style={styles.optionRow}>
                <Text>{String.fromCharCode(97 + i)}.</Text>
                <Text
                  style={[
                    styles.optionText,
                    isCorrect ? styles.correct : isSelected ? styles.incorrect : {},
                  ]}
                >
                  {optionText}
                  {isCorrect && ' ✔️'}
                  {isSelected && !isCorrect && ' ❌'}
                </Text>
              </View>
            );
          })}
        </View>
      ))}

      {/* Footer */}
      <View style={styles.footer} fixed>
        <Text
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
        />
      </View>

    </Page>
  </Document>
);

export default QuizReviewPDF;
